import { z } from "zod";

import { FeedbackRating } from "@classview/shared-types";

const FeedbackRatings: FeedbackRating[] = ["Good", "Bad", "Ok", "Great"];

const callFeedbackSchema = z.object({
  rating: z.enum(FeedbackRatings as [string, ...string[]]).nullable(),
  description: z.string(),
  isUserHappyToBeContacted: z.boolean(),
});

type CallFeedbackFormData = z.infer<typeof callFeedbackSchema>;

export { callFeedbackSchema, FeedbackRatings };
export type { CallFeedbackFormData };
